<template>
  <el-dialog
    class="rc-dialog"
    title="视频共享管理"
    :visible.sync="dialogVisible"
    width="50%"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="close"
  >
    <el-form inline size="small">
      <el-form-item>
        <butn
          v-permission="'videoSet:shareVideo'"
          title="共享"
          :disabled="!shareEnable"
          @click="shareVideoSets"
        ></butn>
        <butn
          v-permission="'videoSet:cancelShareVideo'"
          title="取消共享"
          :disabled="!cancelEnable"
          @click="cancleShare"
        ></butn>
        <butn
          v-permission="'videoSet:recovery'"
          title="恢复"
          :disabled="!recoveryEnable"
          @click="recoveryShare"
        ></butn>
        <el-checkbox
          v-permission="'videoSet:share:online'"
          class="m-l-14"
          v-model="needOnline"
          key="needOnline"
          :true-label="1"
          :false-label="0"
          >共享或恢复后直接上线
        </el-checkbox>
      </el-form-item>
      <!-- <el-form-item>
        <el-input v-model="deptName" placeholder="学院名称"></el-input>
        <butn
          btntype="primary"
          class="left"
          title="查询"
          @click="getData"
        ></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item> -->
    </el-form>
    <Table @selection-change="selectChange" :data="list" />
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Table from "./table.js";
import {
  videoSetSharePage,
  shareVideoSet,
  cancelShareVideoSet,
  recoveryVideoSet,
} from "@/api/videoSet";
import Bus from "../Bus.js";
import { Confirm } from "@/components/Confirm";
import { Message } from "element-ui";
export default {
  components: { butn, Table },
  data() {
    return {
      dialogVisible: false,
      list: [],
      deptName: "",
      api: videoSetSharePage,
      checkArray: [],
      videoId: "",
      shareEnable: false,
      cancelEnable: false,
      recoveryEnable: false,
      needOnline: 0,
    };
  },
  created() {
    Bus.$on("shareManage", (id) => {
      this.dialogVisible = true;
      this.videoId = id;
      this.getData();
    });
    // Bus.$on("reloadShare", this.getData);
  },
  beforeDestroy() {
    Bus.$off("shareManage");
  },

  computed: {
    depIds() {
      return this.checkArray.map((ele) => {
        return ele.deptId;
      });
    },
    sharedToBizIds() {
      return this.checkArray.map((ele) => {
        return ele.sharedToBizId;
      });
    },
  },
  methods: {
    resetData() {
      this.deptName = "";
      this.getData();
    },
    selectChange(selections) {
      this.checkArray = selections;
      if (this.checkArray.length === 0) {
        this.shareEnable = false;
        this.cancelEnable = false;
        this.recoveryEnable = false;
      } else {
        let shareEnable = true;
        let cancelEnable = true;
        let recoveryEnable = true;
        for (const ele of this.checkArray) {
          if (ele.sharedStatus === 0) {
            // 已共享状态不能勾选共享
            shareEnable = false;

            if (ele.isDelete === "1") {
              // 已共享删除状态不能取消共享
              cancelEnable = false;
            } else if (ele.isDelete === "0") {
              // 已共享未删除状态恢复
              recoveryEnable = false;
            }
          } else {
            // 不是已同步状态都不能勾选取消共享、恢复
            cancelEnable = false;
            recoveryEnable = false;
            if (Number(ele.isDelete) === 1) {
              recoveryEnable = true;
              shareEnable = false;
            }
          }
        }
        this.shareEnable = shareEnable;
        this.cancelEnable = cancelEnable;
        this.recoveryEnable = recoveryEnable;
      }
    },
    getData() {
      let params = { uuid: this.videoId };
      if (this.deptName) {
        params["deptName"] = this.deptName;
      }
      videoSetSharePage(params).then((res) => {
        if (!res || res.code != 0) return;
        this.list = res.data;
      });
    },
    shareVideoSets() {
      shareVideoSet({
        uuids: [this.videoId],
        deptIds: this.depIds,
        needOnline: this.needOnline,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.$message({
          message: "共享成功",
          type: "success",
        });
        this.getData();
        Bus.$emit("reload");
      });
    },
    cancleShare() {
      this.$confirm("被共享学院对应视频如果配置了首页或干部之家首页，取消共享后可能影响页面展示，请检查确认", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelShareVideoSet({
          uuids: [this.videoId],
          deptIds: this.depIds,
          needOnline: this.needOnline,
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "取消共享成功",
            type: "success",
          });
          this.getData();
          Bus.$emit("reload");
        });
      })
    },
    async recoveryShare() {
      const text = "确定恢复共享该视频吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        recoveryVideoSet({ 
          uuids: this.sharedToBizIds,
          needOnline: this.needOnline,
        }).then((res) => {
          if (!res || res.code != 0) return;
          Message({
            message: "恢复成功",
            type: "success",
          });
          this.getData();
          Bus.$emit("reload");
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    close() {
      this.shareEnable = false;
      this.cancelEnable = false;
      this.recoveryEnable = false;
      Bus.$emit("reload");
    },
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    max-height: 300px;
  }
  .left {
    margin-left: 10px;
  }
  /deep/ .el-input {
    width: 50%;
  }
}
</style>
